module.exports = __webpack_public_path__ + "static/img/prize_result.a5ceb2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/prize_result.png
// module id = 569
// module chunks = 1